<template>
  <EventsList
    :title="$t('events.my_courses')"
    :events-list="eventsStore.list.hits"
    :all-loaded="eventsStore.allEventsLoaded"
    :loading="eventsStore.list.processing"
    :loaded="eventsStore.list.loaded || !authStore.auth"
    @next="eventsStore.getNext()"
  >
    <template #empty>
      <div class="flex flex-col gap-2 h-full justify-center items-center py-12">
        <template v-if="authStore.auth">
          <div>
            {{ $t('events.no_my_courses') }}
          </div>
          <BaseLink :to="'/academy'" class="block">
            {{ $t('events.upcoming_courses') }}
          </BaseLink>
        </template>
        <template v-else>
          <div class="mb-2">
            {{ $t('events.login_to_see_my_courses') }}
          </div>
          <BaseButton
            theme="primary"
            look="border"
            @click="authStore.openLoginModal"
          >
            {{ $t('header.login') }}
          </BaseButton>
        </template>
      </div>
    </template>
  </EventsList>
</template>

<script setup lang="ts">
import { useEvents } from '~/stores/events'
import { useAuth } from '~/stores/auth'
import { EventType, EventsListTypeMap } from '~/models/events'

const authStore = useAuth()
const eventsStore = useEvents()
const type = EventsListTypeMap.Me

eventsStore.resetEventsListWithType(type, EventType.Course)

if (authStore.auth) {
  onServerPrefetch(async () => {
    await eventsStore.getEvents()
  })

  onBeforeMount(async () => {
    await eventsStore.getEvents()
  })
} else {
  onBeforeMount(() => {
    // clear list after logout on another page
    eventsStore.reset()
  })
}

watch(
  () => !!authStore.auth,
  () => {
    if (authStore.auth) {
      eventsStore.resetEventsListWithType(type, EventType.Course)
      eventsStore.getEvents()
    } else {
      eventsStore.reset()
    }
  }
)

useHeadMeta({
  title: 'My courses',
  description: 'My courses in WN Academy',
})
</script>
